/**
 * Filtrage en direct de la grille produits, sans validation.
 *
 * Le filtrage se fait sur les cartes déjà rendues plutôt que par un appel au
 * serveur : les collections de Shopify ne savent pas répondre à une recherche
 * textuelle, seule la recherche globale le fait, et elle ne sait pas se
 * restreindre à une collection. Quand rien ne correspond dans ce qui est
 * chargé, on propose la recherche globale en secours.
 *
 * Script classique et non module : il est appelé depuis un snippet, sans
 * import ni dépendance au reste du thème.
 */
(function () {
  if (customElements.get('recherche-produits')) return;

  const DELAI = 120;

  /** Minuscules sans accents : « Pétales » doit se trouver en tapant « petales ». */
  function normaliser(texte) {
    return (texte || '')
      .toLowerCase()
      .normalize('NFD')
      // Plage des diacritiques combinants, écrite en échappements : les
      // caractères eux-mêmes sont invisibles dans un fichier et se perdent au
      // premier copier-coller.
      .replace(/[̀-ͯ]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  class RechercheProduits extends HTMLElement {
    connectedCallback() {
      this.champ = this.querySelector('.recherche-produits__champ');
      this.vider = this.querySelector('.recherche-produits__vider');
      this.compte = this.querySelector('.recherche-produits__compte');
      this.forme = this.querySelector('.recherche-produits__forme');
      if (!this.champ) return;

      this.grille = document.querySelector('.product-grid');
      if (!this.grille) return;

      this.index = null;
      this.minuteur = null;

      // La grille se reconstruit quand un filtre est posé ou qu'une page
      // supplémentaire se charge : l'index doit alors être refait.
      this.observateur = new MutationObserver(() => {
        this.index = null;
        if (this.champ.value) this.appliquer();
      });
      this.observateur.observe(this.grille, { childList: true });

      this.champ.addEventListener('input', () => this.differer());
      this.champ.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.reinitialiser();
      });
      if (this.vider) this.vider.addEventListener('click', () => this.reinitialiser());

      // La validation ne doit pas quitter la page : le filtrage est déjà fait.
      if (this.forme) this.forme.addEventListener('submit', (e) => e.preventDefault());

      if (this.champ.value) this.appliquer();
    }

    disconnectedCallback() {
      if (this.observateur) this.observateur.disconnect();
      clearTimeout(this.minuteur);
    }

    construireIndex() {
      const cartes = this.grille.querySelectorAll('.product-grid__item');
      this.index = Array.from(cartes).map((carte) => {
        const nom = carte.querySelector('.text-block');
        const marque = carte.querySelector('.carte-fournisseur');
        return {
          element: carte,
          texte: normaliser(
            [nom && nom.textContent, marque && marque.textContent].filter(Boolean).join(' ')
          ),
        };
      });
    }

    differer() {
      clearTimeout(this.minuteur);
      this.minuteur = setTimeout(() => this.appliquer(), DELAI);
    }

    reinitialiser() {
      this.champ.value = '';
      this.appliquer();
      this.champ.focus();
    }

    appliquer() {
      if (!this.index) this.construireIndex();

      const terme = normaliser(this.champ.value);
      if (this.vider) this.vider.hidden = terme === '';

      if (terme === '') {
        this.index.forEach((e) => (e.element.hidden = false));
        this.annoncer(null, 0);
        return;
      }

      // Chaque mot doit se trouver, dans n'importe quel ordre : « huile fraise »
      // trouve « Huile de massage à la fraise ».
      const mots = terme.split(' ');
      let trouves = 0;
      this.index.forEach((e) => {
        const ok = mots.every((mot) => e.texte.includes(mot));
        e.element.hidden = !ok;
        if (ok) trouves += 1;
      });
      this.annoncer(this.champ.value, trouves);
    }

    annoncer(terme, trouves) {
      if (!this.compte) return;

      if (terme === null) {
        this.compte.hidden = true;
        this.compte.textContent = '';
        return;
      }

      this.compte.hidden = false;
      if (trouves > 0) {
        this.compte.textContent = trouves + (trouves > 1 ? ' produits' : ' produit');
        return;
      }

      // Aucun résultat dans ce qui est chargé : la recherche globale de la
      // boutique prend le relais, elle voit tout le catalogue.
      const vide = this.dataset.vide || 'Aucun produit ne correspond';
      this.compte.textContent = vide + ' — ';
      const lien = document.createElement('a');
      lien.href = '/search?type=product&q=' + encodeURIComponent(terme);
      lien.textContent = 'chercher dans toute la boutique';
      this.compte.appendChild(lien);
    }
  }

  customElements.define('recherche-produits', RechercheProduits);
})();
